import Seo from "../../components/Seo";
import { Reveal, Eyebrow, PageHero, CheckList, PhotoFrame, CtaBand } from "../../components/Shared";
import { PACKAGES, UPGRADES, photo, fmt } from "../../data/site";
import { Link } from "react-router-dom";

const pkg = PACKAGES[0];

export default function Interior() {
  return (
    <>
      <Seo
        title="Interior Detailing in Sioux Falls, SD | From $275 — A+ Detailing"
        description="Interior auto detailing in Sioux Falls from $275: comprehensive vacuum, crevice cleaning, streak-free glass, leather cleaning & conditioning. Shampoo, ozone & engine bay upgrades. Mobile & in-shop."
        path="/interior-detailing"
      />
      <PageHero
        eyebrow="Interior Detailing"
        lines={["A CABIN", "LIKE NEW."]}
        lead="Comprehensive vacuum, crevices cleared of dirt & grime, streak-free glass and leather conditioned to a grease-free matte finish — in-shop or mobile across Sioux Falls."

        chips={[`From ${fmt(pkg.price)} in-shop`, `From ${fmt(pkg.mobilePrice)} mobile`, "Flat rate by vehicle size"]}
        testPrefix="interior"
      />

      <section className="mx-auto max-w-7xl px-5 sm:px-8 py-20 sm:py-28 grid lg:grid-cols-2 gap-14 items-start">
        <div>
          <Reveal><Eyebrow>What's included</Eyebrow></Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-4 font-display text-3xl sm:text-4xl font-extrabold tracking-tight">Interior Detail package</h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-5 text-steel leading-relaxed">{pkg.blurb}</p>
          </Reveal>
          <div className="mt-8">
            <CheckList items={pkg.includes} cols={2} />
          </div>
          <Reveal delay={0.2}>
            <div className="mt-8 flex flex-wrap gap-4 items-center">
              <span className="glass border border-white/10 rounded-full px-5 py-2.5 text-sm">
                In-shop from <strong className="text-bright">{fmt(pkg.price)}</strong>
              </span>
              <span className="glass border border-white/10 rounded-full px-5 py-2.5 text-sm">
                Mobile from <strong className="text-bright">{fmt(pkg.mobilePrice)}</strong>
              </span>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <div className="rounded-2xl border border-white/10 bg-gradient-to-br from-bright/15 via-card to-card p-10 min-h-[460px] lg:min-h-[560px] flex flex-col justify-between" data-testid="interior-price-panel">
            <Eyebrow>Interior Detail</Eyebrow>
            <div>
              <div className="flex items-end gap-3">
                <span className="font-display text-6xl font-extrabold">{fmt(pkg.price)}</span>
                <span className="text-muted text-sm mb-2">in-shop, starting</span>
              </div>
              <p className="mt-3 text-sm text-steel">Mobile from <strong className="text-bright">{fmt(pkg.mobilePrice)}</strong> at your home or office.</p>
              <Link to="/book" data-testid="interior-book-button" className="mt-8 flex items-center justify-center rounded-full bg-bright hover:bg-accent text-white font-semibold px-7 py-3.5 transition-colors">
                Book Interior Detail
              </Link>
            </div>
          </div>
        </Reveal>
      </section>

      <section className="bg-coal border-y border-white/5 py-20 sm:py-28">
        <div className="mx-auto max-w-5xl px-5 sm:px-8">
          <Reveal><Eyebrow>Interior Upgrades</Eyebrow></Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-4 font-display text-3xl sm:text-4xl font-extrabold tracking-tight">Go deeper on any detail.</h2>
          </Reveal>
          <div className="mt-10 rounded-2xl border border-white/10 bg-card overflow-hidden" data-testid="interior-upgrades">
            {UPGRADES.map((u, i) => (
              <div key={i} className="flex items-center justify-between gap-6 px-6 sm:px-8 py-5 border-b border-white/5 last:border-0 hover:bg-white/[0.02] transition-colors">
                <span className="text-sm text-steel">{u.name}</span>
                <span className="font-mono text-sm text-bright shrink-0">+{fmt(u.price)}</span>
              </div>
            ))}
          </div>
          <Reveal delay={0.15}>
            <p className="mt-5 text-sm text-muted">
              Upgrades can be added to any package — mention what you need when you{" "}
              <Link to="/book" className="text-bright hover:text-white transition-colors">book your detail</Link>.
            </p>
          </Reveal>
        </div>
      </section>

      <CtaBand testPrefix="interior" />
    </>
  );
}
